import type { ConfigTagsTableProps } from './ConfigTagsTable.types'
import '../CreateEntityForm/CreateEntityForm.css'
import '../DetailEntityFields/DetailEntityFields.css'
import './ConfigTagsTable.css'

// Read-only view of a config's tags, rendered as a key/value table that matches
// the detail page's field table styling. Bare (no heading) — it sits inside the
// value cell of a "Tags" labelled row, so the label comes from the parent.
export function ConfigTagsTable({ tags }: ConfigTagsTableProps) {
  const entries = Object.entries(tags)

  if (entries.length === 0) {
    return <span className="config-tags-table-empty">No tags</span>
  }

  return (
    <div className="create-form-table config-tags-table">
      {entries.map(([key, value], index) => {
        const isLast = index === entries.length - 1
        return (
          <div
            key={key}
            className={isLast ? 'create-form-row--last' : 'create-form-row'}
          >
            <div className="create-form-label">{key}</div>
            <div className="detail-form-value-cell">{value}</div>
          </div>
        )
      })}
    </div>
  )
}
